<template>
    <div class="slider slider3">
        <div class="user-ava"></div>
        <div class="box-middle">
            <div class="w100 h100 box3-cnt">
                <div class="title"></div>
                <div class="defaultPro progress-size" v-if="preview < 100000"></div>
                <!-- 根据值判断进度条进度 -->
                <div v-else>
                    <div v-for="(value, fKey) in previewList" :key="fKey" class="mt-12">
                        <div class="progress-size"
                            :class="['item' + (fKey + 1), (preview >= value && ((fKey + 1) === previewList.length || preview < previewList[fKey + 1])) ? 'pimg-block' : 'pimg-none',]">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    // props: ["preview"],
    data() {
        return {
            previewList: [100000, 300000, 500000, 800000, 1000000], // 卡片
            preview: 0,
        }
    },
    created() {
    },
    methods: {

    }
}
</script>
<style lang="scss" scoped>
.slider3 {
    background: url("../../assets/img/m3/bg.png") no-repeat top;
    background-size: cover;
    width: 100%;
    height: 100%;

    .user-ava {
        background: url("../../assets/img/m3/user.png") no-repeat top;
        background-size: 100% 100%;
        width: 1920px;
        height: 1080px;
        position: absolute;
        bottom: 0;
    }

    .box-middle {

        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;

        display: flex;
        align-items: center;
        justify-content: center;
        flex-flow: column;

        .box3-cnt {
            position: relative;
        }

        .title {
            background: url("../../assets/img/m3/title.png") no-repeat top;
            background-size: 100% 100%;
            width: 1120px;
            height: 61px;
            margin: 30px auto;
        }

        .pimg-block {
            display: block;
        }

        .pimg-none {
            display: none;
        }

        .progress-size {
            width: 1920px;
            height: 1080px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .defaultPro {
            background: url("../../assets/img/m3/defaultPro.png") no-repeat top;
            background-size: 100% 100%;

        }

        .item1 {
            background: url("../../assets/img/m3/progress10.png") no-repeat center top;
            background-size: 100% 100%;
        }

        .item2 {
            background: url("../../assets/img/m3/progress30.png") no-repeat center top;
            background-size: 100% 100%;
        }

        .item3 {
            background: url("../../assets/img/m3/progress50.png") no-repeat center top;
            background-size: 100% 100%;
        }

        .item4 {
            background: url("../../assets/img/m3/progress80.png") no-repeat center top;
            background-size: 100% 100%;
        }

        .item5 {
            background: url("../../assets/img/m3/progress100.png") no-repeat center top;
            background-size: 100% 100%;
        }

    }
}


@media screen and (min-width: 2560px) and (max-width: 3440px) {
    .user-ava {
        width: 1536px !important;
        height: 864px !important;
        right: 0;
    }

    .box-middle {
        .title {
            width: 896px !important;
            height: 49px !important;
        }

        .progress-size {
            width: 1440px !important;
            height: 810px !important;
            // left: 50%;
            // transform: translate(-50%, 0);
        }
    }

}</style>



// WEBPACK FOOTER //
// src/components/publicComponents/slider3.vue